import { ExternalLink, FileJson2 } from 'lucide-react';
import { GlassPanel } from '../../components/GlassPanel.js';

/**
 * Admin → API: the OpenAPI documentation, visible from the interface instead
 * of only for those who know the address (07 — 2.2.4). The docs themselves
 * are served by the API (Swagger UI on /api/docs) and embedded here through
 * the same proxy the rest of the app talks through.
 */
export function ApiDocsAdmin() {
  return (
    <div className="space-y-3">
      <GlassPanel>
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            <h2 className="font-display text-ink text-base">Nova API</h2>
            <p className="text-ink-soft mt-1 max-w-2xl text-sm leading-relaxed">
              Alt grensesnittet gjør, gjør det gjennom dette API-et — og agentene bruker det samme.
              Mennesker autentiseres med sesjonsinformasjonskapselen; agentene bruker tjenestetoken.
              Dokumentasjonen under er generert fra koden og er alltid i takt med det som faktisk
              kjører.
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <a
              href="/api/docs"
              target="_blank"
              rel="noreferrer noopener"
              className="border-hairline bg-raised/60 text-ink hover:bg-raised inline-flex h-8 items-center gap-1.5 rounded-lg border px-3 text-xs transition"
            >
              Åpne i egen fane <ExternalLink size={12} aria-hidden />
            </a>
            <a
              href="/api/docs/json"
              target="_blank"
              rel="noreferrer noopener"
              className="border-hairline bg-raised/60 text-ink-soft hover:text-ink inline-flex h-8 items-center gap-1.5 rounded-lg border px-3 text-xs transition"
              title="Maskinlesbar OpenAPI-spesifikasjon"
            >
              <FileJson2 size={12} aria-hidden /> OpenAPI JSON
            </a>
          </div>
        </div>
      </GlassPanel>

      {/* Swagger UI kommer med sitt eget lyse utseende — innrammet her, i
          stedet for restilt, så dokumentasjonen ser ut som utviklere venter. */}
      <div className="border-hairline rounded-panel overflow-hidden border bg-white">
        <iframe src="/api/docs" title="Nova API-dokumentasjon" className="h-[72vh] w-full" />
      </div>
    </div>
  );
}
